import { render } from "./searchlist.vue?vue&type=template&id=2b38b2d6"
import script from "./searchlist.vue?vue&type=script&lang=js"
export * from "./searchlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__